import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { ReactNode } from 'react';

interface HostOnlyRouteProps {
  children: ReactNode;
}

const HostOnlyRoute = ({ children }: HostOnlyRouteProps) => {
  const { user, isLoading } = useAuth();

  if (isLoading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
      </div>
    );
  }

  // If user is not authenticated, redirect to login (handled by ProtectedRoute)
  if (!user) {
    return <Navigate to="/login" replace />;
  }

  // If user is not a host, redirect to dashboard
  if (!user.is_host) {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
};

export default HostOnlyRoute;
